import type { IconSvgObject } from './types';

const EquipmentGym03Icon: IconSvgObject = [
  ["path", { d: "M18 3.5V8.5M6 3.5V8.5M20.5 4.5V6M20.5 6V7.5M20.5 6H21.5M3.5 4.5V6M3.5 6V7.5M3.5 6H2.5M18 6H6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 18H18.9995L16.9999 14H6.99995L5 18Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 8.5V14M15 8.5V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16 18V20.5M8 18V20.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default EquipmentGym03Icon;
